import useTranslate from '@hooks/useTranslate';
import { FunctionComponent, useState } from 'react';
import componentContent from '../SpamUserCard.content.json';
import { Empty, Modal, Space, Spin, Table } from 'antd';
import css from './ChatClaims.module.less';
import IUser from '@interfaces/IUser';
import { useStore } from 'effector-react';
import chatClaims from '@stores/chat-claims';
import { ColumnsType } from 'antd/lib/table';
import cn from 'classnames';
import moment from 'moment';
import getChatRecipientName from '@helpers/getChatRecipientName';

interface ChatClaimsProps {
  chatClaimsTable: any;
  isLoading: boolean;
  onOpen: (value: boolean) => void;
  user?: IUser | null;
}

const ChatClaims: FunctionComponent<ChatClaimsProps> = (props) => {
  const { pagination } = useStore(chatClaims);
  const [isOpened, setIsOpened] = useState(false);
  const content = useTranslate(componentContent);
  const { isLoading, onOpen, chatClaimsTable, user } = props;

  const handleOpen = () => {
    const nextValue = !isOpened;
    setIsOpened(nextValue);
    onOpen(nextValue);
  };

  const handleClose = () => {
    setIsOpened(false);
  };

  const columns: ColumnsType<any> = [
    {
      key: 'created',
      dataIndex: 'created',
      title: content.created,
      render: (value: string) => (value ? moment(value).format('DD.MM.YYYY HH:mm') : '-'),
    },
    {
      key: 'text',
      dataIndex: 'text',
      title: content.comment,
    },
    {
      key: 'nickname',
      dataIndex: 'nickname',
      title: content.nickname,
    },
    {
      key: 'chatOrTribe',
      dataIndex: 'chatOrTribe',
      title: content.chatOrTribe,
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: content.reason,
    },
  ];

  const dataSource = (chatClaimsTable || []).map((claim: any) => ({
    id: claim.id,
    text: claim.text || '-',
    created: claim.created,
    nickname: getChatRecipientName(claim),
    chatOrTribe: claim.chatId || claim.tribe?.chatId || '-',
    type: claim.type || '-',
  }));

  const count = Number(user?.chatClaimsCount || 0);

  return (
    <div>
      <Space onClick={count > 0 ? handleOpen : undefined}>
        <div
          className={cn(css.text, {
            [css.active]: count > 0,
          })}
        >
          {content.chatClaims}: {count}
        </div>
      </Space>

      <Modal
        visible={isOpened}
        title={
          <div>
            <div>{`${content.chatClaims}: ${user?.chatClaimsCount || 0}`}</div>
            <div className={css.userNickname}>
              {user?.nickname && (
                <a
                  className={css.nicknameLink}
                  href={`/user-list/${user?.id}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  {user?.nickname}
                </a>
              )}
            </div>
          </div>
        }
        footer={null}
        onCancel={handleClose}
        width={1000}
        destroyOnClose
        keyboard
      >
        <Spin spinning={isLoading}>
          {dataSource.length > 0 ? (
            <Table
              rowKey='id'
              dataSource={dataSource}
              columns={columns}
              pagination={{
                pageSizeOptions: ['3', '5', '10', '20'],
                showSizeChanger: true,
                position: ['topRight'],
                defaultPageSize: 3,
                current: pagination?.current,
                pageSize: pagination?.pageSize,
              }}
            />
          ) : (
            <Empty
              className={css.emptyContainer}
              imageStyle={{ height: '50px' }}
            />
          )}
        </Spin>
      </Modal>
    </div>
  );
};

export default ChatClaims;
